import ActiveAssetRegister from "./ActiveAssetRegisters"
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRegionDropDown } from "Store/Organization/Region/RegionAction";
import { getMarketDropDown } from "Store/Organization/Market/MarketAction";
import { getCostCenterByMarket } from "Store/Organization/CostCenterByMarket/CostCenterByMarketAction";
import { base64ToArrayBuffer, formatPrice, saveByteArray } from "utils";
import { getActiveAssetExcelData, getActiveAssetGridData, setActiveAssetExcelData, setActiveAssetGridFilter } from "Store/AssetManagement/ActiveAssetDashboard/ActiveAssetDashboardAction";
import { useDebounce } from "client/CommonComponents/CustomDebounce/DebounceHook";
import userProfileSelectors from '../../../../redux/UserProfile/selectors'
import { getActiveAssetAssetCategoryDropDown, getActiveAssetCostCenterDropDown, getActiveAssetEqClassCodeDropDown, getActiveAssetGLCategoryDropDown, getActiveAssetMakeDropDown, getActiveAssetModelDropDown, getActiveAssetStateDropDown, getActiveAssetYearDropDown } from "Store/AssetManagement/ActiveAssetDropDown/ActiveAssetDropDownAction";
import { CustomDropdownFilterComponent } from "client/Components/OrderManagement/BulkOrder/Home/HomeHelper";
import { useNavigate } from "react-router-dom";

const ActiveAssetRegisterContainer = () => {
    const [regionDropDownList, setRegionDropDownList] = useState<any>([])
    const [selectedRegion, setSelectedRegion] = useState<any>();

    const [marketDropDownList, setMarketDropDownList] = useState<any>([])
    const [selectedMarket, setSelectedMarket] = useState<any>();

    const [costCenterDropdownList, setCostCenterDropdownList] = useState([]);
    const [selectedCostCenter, setSelectedCostCenter] = useState<any>();

    const [globalSearchBy, setGlobalSearchBy] = useState<any>({ value: 'assetNumber', label: 'Asset#' });
    const [searchBoxValue, setsearchBoxValue] = useState('');
    const [showGrid, setShowGrid] = useState(false);
    const [serverTotal, setServerTotal] = useState(0);
    const [paginationData, setPaginationData] = useState<any>({});
    const [pagesCount, setPagesCount] = useState<number>(0);
    const [sortData, setSortData] = useState<any>({});
    const [isClearFilterClicked, setIsClearFilterClicked] = useState<boolean>(false);
    const [savedMarket, setSavedMarket] = useState<any>('')
    const [savedCostCenter, setSavedCostCenter] = useState<any>('');
    const [sentPayload, setSentPayload] = useState<any>({});
    const [gridRemountKey, setGridRemountKey] = useState<number>(0);

    /// useRef for filter dropdown list
    const costCenterList: any = useRef([]);
    const makeList: any = useRef([]);
    const modelList: any = useRef([]);
    const yearList: any = useRef([]);
    const glCategoryList: any = useRef([]);
    const assetCategoryList: any = useRef([]);
    const equipmentClassList: any = useRef([]);
    const stateList: any = useRef([]);

    /// useRef for filter dropdowns
    const costCenterSelected: any = useRef([]);
    const makeSelected: any = useRef([]);
    const modelSelected: any = useRef([]);
    const yearSelected: any = useRef([]);
    const glCategorySelected: any = useRef([]);
    const assetCategorySelected: any = useRef([]);
    const equipmentClassSelected: any = useRef([]);
    const stateSelected: any = useRef([]);

    /// useRef for text filter
    const assetNumberSelected: any = useRef([]);
    const unitNumberSelected: any = useRef([]);
    const vinNumberSelected: any = useRef([]);
    const equipmentClassDescSelected: any = useRef([]);
    const descriptionSelected: any = useRef([]);
    const eqStatusSelected: any = useRef([]);
    const acquisitionCostSelected: any = useRef([]);
    const netBookedValueSelected: any = useRef([]);

    const previousGlobalSearchSignatureRef: any = useRef<string | null>(null);
    const resetToFirstPageOnNextFetchRef: any = useRef<boolean>(false);
    const remountGridOnNextResponseRef: any = useRef<boolean>(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    ///selectors
    const {
        regionDropDown = [],
        marketDropDown = [],
        costCenterByMarketDropDownList = [],
        activeAssetExcelData,
        activeAssetGridFilters,
        activeAssetGridData,
        userDetails,
        isGridDataLoading,
        activeAssetCostCenterDropDown,
        activeAssetMakeDropDown,
        activeAssetModelDropDown,
        activeAssetYearDropDown,
        activeAssetGLCategoryDropDown,
        activeAssetAssetCategoryDropDown,
        activeAssetEqClassCodeDropDown,
        activeAssetStateDropDown
    }: any = useSelector((state: any) => ({
        regionDropDown: state?.RegionDropDownReducer?.regionDropDown,
        marketDropDown: state?.MarketDropDownReducer?.marketDropDown,
        costCenterByMarketDropDownList: state.CostCenterByMarketReducers.costCenterByMarket,
        activeAssetExcelData: state.ActiveAssetDashboardReducer.activeAssetExcelData,
        activeAssetGridFilters: state.ActiveAssetDashboardReducer.activeAssetGridFilters,
        activeAssetGridData: state.ActiveAssetDashboardReducer.activeAssetGridData,
        userDetails: userProfileSelectors.getUserDetails(state),
        isGridDataLoading: state.ActiveAssetDashboardReducer.isGridDataLoading,
        activeAssetCostCenterDropDown: state.ActiveAssetDropDownReducer.activeAssetCostCenterDropDown,
        activeAssetMakeDropDown: state.ActiveAssetDropDownReducer.activeAssetMakeDropDown,
        activeAssetModelDropDown: state.ActiveAssetDropDownReducer.activeAssetModelDropDown,
        activeAssetYearDropDown: state.ActiveAssetDropDownReducer.activeAssetYearDropDown,
        activeAssetGLCategoryDropDown: state.ActiveAssetDropDownReducer.activeAssetGLCategoryDropDown,
        activeAssetAssetCategoryDropDown: state.ActiveAssetDropDownReducer.activeAssetAssetCategoryDropDown,
        activeAssetEqClassCodeDropDown: state.ActiveAssetDropDownReducer.activeAssetEqClassCodeDropDown,
        activeAssetStateDropDown: state.ActiveAssetDropDownReducer.activeAssetStateDropDown
    }));

    useEffect(() => {
        if(regionDropDown?.length == 0 || regionDropDown == undefined || regionDropDown == null){
            dispatch(getRegionDropDown());
        }
        if(activeAssetCostCenterDropDown?.length == 0 || activeAssetCostCenterDropDown == undefined || activeAssetCostCenterDropDown == null){
            dispatch(getActiveAssetCostCenterDropDown())
        }
        if(activeAssetMakeDropDown?.length == 0 || activeAssetMakeDropDown == undefined || activeAssetMakeDropDown == null){
            dispatch(getActiveAssetMakeDropDown())
        }
        if(activeAssetModelDropDown?.length == 0 || activeAssetModelDropDown == undefined || activeAssetModelDropDown == null){
            dispatch(getActiveAssetModelDropDown())
        }
        if(activeAssetYearDropDown?.length == 0 || activeAssetYearDropDown == undefined || activeAssetYearDropDown == null){
            dispatch(getActiveAssetYearDropDown())
        }
        if(activeAssetGLCategoryDropDown?.length == 0 || activeAssetGLCategoryDropDown == undefined || activeAssetGLCategoryDropDown == null){
            dispatch(getActiveAssetGLCategoryDropDown())
        }
        if(activeAssetAssetCategoryDropDown?.length == 0 || activeAssetAssetCategoryDropDown == undefined || activeAssetAssetCategoryDropDown == null){
            dispatch(getActiveAssetAssetCategoryDropDown())
        }
        if(activeAssetEqClassCodeDropDown?.length == 0 || activeAssetEqClassCodeDropDown == undefined || activeAssetEqClassCodeDropDown == null){
            dispatch(getActiveAssetEqClassCodeDropDown())
        }
        if(activeAssetStateDropDown?.length == 0 || activeAssetStateDropDown == undefined || activeAssetStateDropDown == null){
            dispatch(getActiveAssetStateDropDown())
        }
        setShowGrid(true);
        setSentPayload({})
        setsearchBoxValue(activeAssetGridFilters?.orderSearchBoxValue ?? '')
        setGlobalSearchBy((activeAssetGridFilters?.globalSearchField && activeAssetGridFilters?.orderSearchBoxValue) ? activeAssetGridFilters?.globalSearchField : { value: 'assetNumber', label: 'Asset #' })
    }, [])

    useEffect(() => {
        if (activeAssetGridData?.status == 'success') {
            setIsClearFilterClicked(false)
            setServerTotal(activeAssetGridData?.response?.totalRecords)
            if (remountGridOnNextResponseRef.current) {
                remountGridOnNextResponseRef.current = false
                setShowGrid(false)
                setTimeout(() => {
                    setShowGrid(true);
                })
            }
        }
    }, [activeAssetGridData])

    useEffect(() => {
        if (regionDropDown?.length) {
            const regionDropDownTemp = regionDropDown?.map((item: any) =>
                ({ label: item.text, key: item.value, ...item })
            );
            setRegionDropDownList(regionDropDownTemp);
        }
    }, [regionDropDown])

    useEffect(() => {
        if (marketDropDown?.length) {
            const marketDropDownTemp = marketDropDown?.map((item: any) =>
                ({ label: item.text, key: item.value, ...item })
            );
            setMarketDropDownList(marketDropDownTemp);
            if (savedMarket) {
                let val = marketDropDownTemp?.find((val?: any) => val.key == savedMarket)
                setSelectedMarket(val)
                setSavedMarket('')
                dispatch(setActiveAssetGridFilter({ ...activeAssetGridFilters, market: val }))
            }
        }
    }, [marketDropDown])

    useEffect(() => {
        if (costCenterByMarketDropDownList?.length) {
            const costCenterDropdownListTemp = costCenterByMarketDropDownList?.map((item: any, _index: number) => ({ ...item, label: item?.text, key: item?.value }));
            setCostCenterDropdownList(costCenterDropdownListTemp);
            if (savedCostCenter) {
                let val = costCenterDropdownListTemp?.find((val?: any) => val.key == savedCostCenter)
                setSelectedCostCenter(val)
                setSavedCostCenter('')
                dispatch(setActiveAssetGridFilter({ ...activeAssetGridFilters, costCenterSearch: val }))
            }
        }
    }, [costCenterByMarketDropDownList])

    useEffect(() => {
        if (activeAssetCostCenterDropDown?.length) {
            costCenterList.current = activeAssetCostCenterDropDown?.map((item: any) => ({ label: item?.text, value: item?.value }));
        }
    }, [activeAssetCostCenterDropDown])

    useEffect(() => {
        if (activeAssetMakeDropDown?.length) {
            makeList.current = activeAssetMakeDropDown?.map((item: any) => ({ label: item?.text, value: item?.value }));
        }
    }, [activeAssetMakeDropDown])

    useEffect(() => {
        if (activeAssetModelDropDown?.length) {
            modelList.current = activeAssetModelDropDown?.map((item: any) => ({ label: item?.text, value: item?.value }));
        }
    }, [activeAssetModelDropDown])

    useEffect(() => {
        if (activeAssetYearDropDown?.length) {
            yearList.current = activeAssetYearDropDown?.map((item: any) => ({ label: item?.text, value: item?.value }));
        }
    }, [activeAssetYearDropDown])

    useEffect(() => {
        if (activeAssetGLCategoryDropDown?.length) {
            glCategoryList.current = activeAssetGLCategoryDropDown?.map((item: any) => ({ label: item?.text, value: item?.value }));
        }
    }, [activeAssetGLCategoryDropDown])

    useEffect(() => {
        if (activeAssetAssetCategoryDropDown?.length) {
            assetCategoryList.current = activeAssetAssetCategoryDropDown?.map((item: any) => ({ label: item?.text, value: item?.value }));
        }
    }, [activeAssetAssetCategoryDropDown])

    useEffect(() => {
        if (activeAssetEqClassCodeDropDown?.length) {
            equipmentClassList.current = activeAssetEqClassCodeDropDown?.map((item: any) => ({ label: item?.text, value: item?.value }));
        }
    }, [activeAssetEqClassCodeDropDown])

    useEffect(() => {
        if (activeAssetStateDropDown?.length) {
            stateList.current = activeAssetStateDropDown?.map((item: any) => ({ label: item?.text, value: item?.value }));
        }
    }, [activeAssetStateDropDown])

    const alreadyHasValues = () => {
        let isAlreadyHasValues = false
        Object.keys(clearFilterValues)?.forEach((filterItem?: any) => {
            Object.keys(activeAssetGridFilters ?? {})?.forEach((gridItem?: any) => {
                if (filterItem == gridItem) {
                    isAlreadyHasValues = true
                }
            })
        })
        return isAlreadyHasValues
    }

    const setSavedFilterValues = () => {
        if (userDetails?.hasOwnProperty('userGridFilters') && regionDropDownList?.length > 0) {
            if (!alreadyHasValues()) {
                let filterObj: any = []
                userDetails?.userGridFilters?.map((item: any) => {
                    if (item?.pageName == "Active Asset") {
                        item?.gridFilter?.map((itemVal?: any) => {
                            if (itemVal?.gridName == "Dashboard")
                                itemVal?.filterValues?.map((val?: any) => {
                                    if (val?.filterName == "region" && regionDropDownList?.length > 0 && val?.filterValue) {
                                        dispatch(getMarketDropDown(val?.filterValue))
                                        let regionTemp: any = regionDropDownList?.find((item?: any) => item?.value == val?.filterValue)
                                        if (regionTemp) {
                                            setSelectedRegion(regionTemp)
                                            filterObj[val?.filterName] = regionTemp
                                        }
                                    } else if (val?.filterName == "market" && val?.filterValue) {
                                        dispatch(getCostCenterByMarket({ marketId: val?.filterValue }, true))
                                        setSavedMarket(val?.filterValue)
                                    } else if (val?.filterName == "costCenterSearch" && val?.filterValue) {
                                        setSavedCostCenter(val?.filterValue)
                                    } else if (val?.filterName == "costCenter") {
                                        const findValue = costCenterList?.current?.find((item: any) => item.label == val?.filterValue)
                                        costCenterSelected.current = findValue?.label
                                        filterObj[val?.filterName] = findValue?.label
                                    }
                                    else if (val?.filterName == "make") {
                                        const findValue = makeList?.current?.find((item: any) => item.value == val?.filterValue)
                                        makeSelected.current = findValue?.label
                                        filterObj[val?.filterName] = findValue?.label
                                    }
                                    else if (val?.filterName == "model") {
                                        const findValue = modelList?.current?.find((item: any) => item.value == val?.filterValue)
                                        modelSelected.current = findValue?.label
                                        filterObj[val?.filterName] = findValue?.label
                                    }
                                    else if (val?.filterName == "year") {
                                        const findValue = yearList?.current?.find((item: any) => item.value == val?.filterValue)
                                        yearSelected.current = findValue?.label
                                        filterObj[val?.filterName] = findValue?.label
                                    }
                                    else if (val?.filterName == "glCategory") {
                                        const findValue = glCategoryList?.current?.find((item: any) => item.value == val?.filterValue)
                                        glCategorySelected.current = findValue?.label
                                        filterObj[val?.filterName] = findValue?.label
                                    }
                                    else if (val?.filterName == "assetCategory") {
                                        const findValue = assetCategoryList?.current?.find((item: any) => item.value == val?.filterValue)
                                        assetCategorySelected.current = findValue?.label
                                        filterObj[val?.filterName] = findValue?.label
                                    }
                                    else if (val?.filterName == "equipmentClass") {
                                        const findValue = equipmentClassList?.current?.find((item: any) => item.value == val?.filterValue)
                                        equipmentClassSelected.current = findValue?.label
                                        filterObj[val?.filterName] = findValue?.label
                                    }
                                    else if (val?.filterName == "state") {
                                        const findValue = stateList?.current?.find((item: any) => item.value == val?.filterValue)
                                        stateSelected.current = findValue?.label
                                        filterObj[val?.filterName] = findValue?.label
                                    } else {
                                        filterObj[val?.filterName] = val?.filterValue
                                    }

                                })

                            dispatch(setActiveAssetGridFilter(filterObj));
                        });
                    }
                })
            } else {
                costCenterSelected.current = activeAssetGridFilters?.costCenter ?? ''
                makeSelected.current = activeAssetGridFilters?.make ?? ''
                modelSelected.current = activeAssetGridFilters?.model ?? ''
                yearSelected.current = activeAssetGridFilters?.year ?? ''
                glCategorySelected.current = activeAssetGridFilters?.glCategory ?? ''
                assetCategorySelected.current = activeAssetGridFilters?.assetCategory ?? ''
                equipmentClassSelected.current = activeAssetGridFilters?.equipmentClass ?? ''
                stateSelected.current = activeAssetGridFilters?.state ?? ''

                assetNumberSelected.current = ''
                unitNumberSelected.current = ''
                vinNumberSelected.current = ''
                equipmentClassDescSelected.current = ''
                descriptionSelected.current = ''
                eqStatusSelected.current = ''
                acquisitionCostSelected.current = ''
                netBookedValueSelected.current = ''

                if (activeAssetGridFilters?.region) {
                    setSelectedRegion(activeAssetGridFilters?.region)
                    dispatch(getMarketDropDown(activeAssetGridFilters?.region?.key))
                }
                if (activeAssetGridFilters?.market) {
                    dispatch(getCostCenterByMarket({ marketId: activeAssetGridFilters?.market?.key }, true))
                    setSelectedMarket(activeAssetGridFilters?.market)
                }
                if (activeAssetGridFilters?.costCenterSearch) {
                    setSelectedCostCenter(activeAssetGridFilters?.costCenterSearch)
                }
            }
        }
    }

    useEffect(() => {
        if (regionDropDownList?.length && costCenterList?.current?.length && modelList?.current?.length && yearList?.current?.length && glCategoryList?.current?.length && assetCategoryList?.current?.length && equipmentClassList?.current?.length && stateList?.current?.length && userDetails?.hasOwnProperty('userGridFilters') && !isClearFilterClicked) {
            setSavedFilterValues()
        }
    }, [userDetails, regionDropDownList, costCenterList?.current, makeList?.current, modelList?.current, yearList?.current, glCategoryList?.current, assetCategoryList?.current ,equipmentClassList?.current, stateList?.current])

    useEffect(() => {
        if (activeAssetExcelData != null && activeAssetExcelData?.status == "success" && activeAssetExcelData?.response?.length) {
            const bytes = base64ToArrayBuffer(activeAssetExcelData?.response);
            saveByteArray("ActiveAssets", bytes, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            dispatch(setActiveAssetExcelData([]));
        }
    }, [activeAssetExcelData])

    useEffect(() => {
        assetNumberSelected.current = activeAssetGridFilters?.assetNumber ?? ''
    }, [activeAssetGridFilters?.assetNumber])

    useEffect(() => {
        unitNumberSelected.current = activeAssetGridFilters?.unitNumber ?? ''
    }, [activeAssetGridFilters?.unitNumber])

    useEffect(() => {
        vinNumberSelected.current = activeAssetGridFilters?.vinNumber ?? ''
    }, [activeAssetGridFilters?.vinNumber])

    useEffect(() => {
        equipmentClassDescSelected.current = activeAssetGridFilters?.equipmentClassDesc ?? ''
    }, [activeAssetGridFilters?.equipmentClassDesc])

    useEffect(() => {
        descriptionSelected.current = activeAssetGridFilters?.description ?? ''
    }, [activeAssetGridFilters?.description])

    useEffect(() => {
        eqStatusSelected.current = activeAssetGridFilters?.eqStatus ?? ''
    }, [activeAssetGridFilters?.eqStatus])

    useEffect(() => {
        acquisitionCostSelected.current = activeAssetGridFilters?.acquisitionCost ?? ''
    }, [activeAssetGridFilters?.acquisitionCost])

    useEffect(() => {
        netBookedValueSelected.current = activeAssetGridFilters?.netBookedValue ?? ''
    }, [activeAssetGridFilters?.netBookedValue])

    const debounceObject = [
        paginationData, searchBoxValue, sortData, costCenterSelected, makeSelected, modelSelected, yearSelected, glCategorySelected, assetCategorySelected , equipmentClassSelected, stateSelected, globalSearchBy, assetNumberSelected, unitNumberSelected, vinNumberSelected, equipmentClassDescSelected, descriptionSelected, eqStatusSelected, acquisitionCostSelected, netBookedValueSelected, isClearFilterClicked, userDetails
    ]
    const globalDebounce = useDebounce(debounceObject, 500)

    const getFilteredValues = () => {
        let filteredValues: any = [];
        if (costCenterSelected.current != "" && costCenterSelected.current != undefined) {
            filteredValues.push({ 'field': 'costCenter', 'value': costCenterSelected.current })
        }
        if (makeSelected.current != "" && makeSelected.current != undefined) {
            filteredValues.push({ 'field': 'make', 'value': makeSelected.current })
        }
        if (modelSelected.current != "" && modelSelected.current != undefined) {
            filteredValues.push({ 'field': 'model', 'value': modelSelected.current })
        }
        if (yearSelected.current != "" && yearSelected.current != undefined) {
            filteredValues.push({ 'field': 'year', 'value': yearSelected.current })
        }
        if (glCategorySelected.current != "" && glCategorySelected.current != undefined) {
            filteredValues.push({ 'field': 'glCategory', 'value': glCategorySelected.current })
        }
        if (assetCategorySelected.current != "" && assetCategorySelected.current != undefined) {
            filteredValues.push({ 'field': 'assetCategory', 'value': assetCategorySelected.current })
        }
        if (equipmentClassSelected.current != "" && equipmentClassSelected.current != undefined) {
            filteredValues.push({ 'field': 'equipmentClass', 'value': equipmentClassSelected.current })
        }
        if (stateSelected.current != "" && stateSelected.current != undefined) {
            filteredValues.push({ 'field': 'state', 'value': stateSelected.current })
        }
        if (assetNumberSelected.current != "" && assetNumberSelected.current != undefined) {
            filteredValues.push({ 'field': 'assetNumber', 'value': assetNumberSelected.current })
        }
        if (unitNumberSelected.current != "" && unitNumberSelected.current != undefined) {
            filteredValues.push({ 'field': 'unitNumber', 'value': unitNumberSelected.current })
        }
        if (vinNumberSelected.current != "" && vinNumberSelected.current != undefined) {
            filteredValues.push({ 'field': 'vinNumber', 'value': vinNumberSelected.current })
        }
        if (equipmentClassDescSelected.current != "" && equipmentClassDescSelected.current != undefined) {
            filteredValues.push({ 'field': 'equipmentClassDesc', 'value': equipmentClassDescSelected.current })
        }
        if(descriptionSelected.current != "" && descriptionSelected.current != undefined) {
            filteredValues.push({ 'field': 'description', 'value': descriptionSelected.current })
        }
        if (eqStatusSelected.current != "" && eqStatusSelected.current != undefined) {
            filteredValues.push({ 'field': 'eqStatus', 'value': eqStatusSelected.current })
        }
        if (acquisitionCostSelected.current != "" && acquisitionCostSelected.current != undefined) {
            filteredValues.push({ 'field': 'acquisitionCost', 'value': acquisitionCostSelected.current })
        }
        if (netBookedValueSelected.current != "" && netBookedValueSelected.current != undefined) {
            filteredValues.push({ 'field': 'netBookedValue', 'value': netBookedValueSelected.current })
        }

        return filteredValues;
    }

    const syncPaginationToFirstPage = useCallback(() => {
        setPaginationData((prev: any) => {
            const nextPaginationData = { ...prev, pageIndex: 0 }
            dispatch(setActiveAssetGridFilter(nextPaginationData));
            return nextPaginationData
        })
    }, [dispatch])

    const fetchGridData = (callType?: any) => {
        const shouldForceFirstPageForSearch = resetToFirstPageOnNextFetchRef.current
        let payload: any = {
            "pageNumber": shouldForceFirstPageForSearch ? 1 : paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined,
            "pageSize": paginationData?.pageSize,
            "columnFilters": isClearFilterClicked ? [] : getFilteredValues(),
            "loggedInMail": userDetails?.emailId
        }
        if (searchBoxValue) {
            payload.globalSearch = searchBoxValue
            payload.globalSearchField = globalSearchBy.value
        }
        if (selectedRegion?.label) {
            payload.regionId = isClearFilterClicked ? '' : selectedRegion?.key
        }
        if (selectedMarket?.label) {
            payload.marketId = isClearFilterClicked ? '' : selectedMarket?.key
        }
        if (selectedCostCenter?.label) {
            payload.costCenterId = isClearFilterClicked ? '' : selectedCostCenter?.key
        }

        if (sortData?.key != '') {
            payload.sortBy = sortData?.key;
            payload.sortOrder = sortData?.sortDirection;
        }

        // Only the grid fetch consumes the "force page 1" intent — an Excel export triggered in
        // between should not swallow a pending search-triggered page reset meant for the grid fetch.
        if (callType === "grid") {
            resetToFirstPageOnNextFetchRef.current = false
        }

        if (userDetails?.emailId) {
            const areEqual = JSON.stringify(payload) === JSON.stringify(sentPayload);
            if (callType === "excel") {
                dispatch(getActiveAssetExcelData(payload));
            } else if(!areEqual && callType === "grid") {
                setSentPayload(payload)
                dispatch(getActiveAssetGridData(payload))
            }
        }
    }

    // Force page 1 only when the global search term actually changes (not on every fetch while a search is active),
    // so subsequent pager clicks (page 2/3...) while a search is active are respected.
    useEffect(() => {
        const normalizedSearchText = `${searchBoxValue ?? ''}`.trim()
        const currentSearchSignature = `${globalSearchBy?.value ?? globalSearchBy ?? ''}::${normalizedSearchText}`
        const currentPageIndex = paginationData?.pageIndex ?? 0

        if (previousGlobalSearchSignatureRef.current === null) {
            previousGlobalSearchSignatureRef.current = currentSearchSignature
            return
        }

        const hasSearchChanged = currentSearchSignature !== previousGlobalSearchSignatureRef.current
        previousGlobalSearchSignatureRef.current = currentSearchSignature

        if (hasSearchChanged) {
            resetToFirstPageOnNextFetchRef.current = true
            remountGridOnNextResponseRef.current = true
            if (currentPageIndex !== 0) {
                syncPaginationToFirstPage()
                setGridRemountKey((k: number) => k + 1)
            }
        }
    }, [globalDebounce, paginationData?.pageIndex, syncPaginationToFirstPage])

    useEffect(() => {
        fetchGridData("grid")
    }, [globalDebounce])

    useEffect(() => {
        if (searchBoxValue) {
            resetToFirstPageOnNextFetchRef.current = true
            remountGridOnNextResponseRef.current = true
            fetchGridData("grid")
        }
    }, [globalSearchBy])

    const breadcrumlist = [
        { text: "Active Assets Registers", key: "f2" }, {}
    ];

    const handleChange = (value: any, name: string) => {
        switch (name) {
            case "region":
                setSelectedRegion(value);
                setSelectedMarket('')
                setSelectedCostCenter('')
                dispatch(getMarketDropDown(value?.key))
                break;
            case "market":
                setSelectedMarket(value);
                setSelectedCostCenter('')
                dispatch(getCostCenterByMarket({ marketId: value?.key }, true))
                break;
            case "costCenter":
                setSelectedCostCenter(value);
                break;
            default:
                break;
        }
    }

    const getFilteredValue = (columnName: any) => {
        return activeAssetGridFilters[columnName];
    }

    const onOrderIdClicked = (e: any, row: any) => {
        e.preventDefault();
        navigate('/ordermanagement/activeasset/activeassetdashboard/'+ row.rowData.assetNumber);
    }

    const handleClearFilter = (filterName: string) => {
        switch (filterName) {
            case "costCenter":
                dispatch(setActiveAssetGridFilter({ costCenter: '' }));
                break;
            case "make":
                dispatch(setActiveAssetGridFilter({ make: '' }));
                break;
            case "model":
                dispatch(setActiveAssetGridFilter({ model: '' }));
                break;
            case "year":
                dispatch(setActiveAssetGridFilter({ year: '' }));
                break;
            case "glCategory":
                dispatch(setActiveAssetGridFilter({ glCategory: '' }));
                break;
            case "assetCategory":
                dispatch(setActiveAssetGridFilter({ assetCategory: '' }));
                break;
            case "equipmentClass":
                dispatch(setActiveAssetGridFilter({ equipmentClass: '' }));
                break;
            case "state":
                dispatch(setActiveAssetGridFilter({ state: '' }));
                break;
            default:
                break;
        }
    }

    const activeAssetRegisterColumn = [
        {
            key: "assetNumber",
            title: "Asset ID",
            width: 70,
            Cell: (row: any) => {
                return (
                    <a href="/" onClick={(e: any) => {
                        onOrderIdClicked(e, row);
                      }} className="order-link-id">
                        {row.rowData.assetNumber}
                    </a>
                );
            },
            style: { textAlign: 'center' },
            id: 'action-column',
            filterRowValue: getFilteredValue('assetNumber') ?? ''
        },
        {
            key: "unitNumber",
            title: "Unit #",
            width: 120,
            filterRowValue: getFilteredValue('unitNumber') ?? ''
        },
        {
            key: "vinNumber",
            title: "VIN / Serial #",
            width: 120,
            filterRowValue: getFilteredValue('vinNumber') ?? ''
        },
        {
            key: "costCenter",
            title: "Cost Center",
            width: 200,
            FilterCell: (statusProps: any) => {
                return <CustomDropdownFilterComponent {...statusProps} options={costCenterList?.current} setDropdown={costCenterSelected} handleClearFilter={handleClearFilter} />;
            },
            filterRowValue: getFilteredValue('costCenter') ?? ''
        },
        {
            key: "make",
            title: "Make",
            width: 120,
            FilterCell: (statusProps: any) => {
                return <CustomDropdownFilterComponent {...statusProps} options={makeList?.current} setDropdown={makeSelected} handleClearFilter={handleClearFilter}/>;
            },
            filterRowValue: getFilteredValue('make') ?? ''
        },
        {
            key: "model",
            title: "Model",
            width: 100,
            FilterCell: (statusProps: any) => {
                return <CustomDropdownFilterComponent {...statusProps} options={modelList?.current} setDropdown={modelSelected} handleClearFilter={handleClearFilter}/>;
            },
            filterRowValue: getFilteredValue('model') ?? ''
        },
        {
            key: "year",
            title: "Year",
            width: 100,
            FilterCell: (statusProps: any) => {
                return <CustomDropdownFilterComponent {...statusProps} options={yearList?.current} setDropdown={yearSelected} handleClearFilter={handleClearFilter}/>;
            },
            filterRowValue: getFilteredValue('year') ?? ''
        },
        {
            key: "description",
            title: "Description",
            width: 200,
            filterRowValue: getFilteredValue('description') ?? ''
        },
        {
            key: "glCategory",
            title: "GL Category",
            width: 120,
            FilterCell: (statusProps: any) => {
                return <CustomDropdownFilterComponent {...statusProps} options={glCategoryList?.current} setDropdown={glCategorySelected} handleClearFilter={handleClearFilter}/>;
            },
            filterRowValue: getFilteredValue('glCategory') ?? ''
        },
        {
            key: "assetCategory",
            title: "Asset Category",
            width: 120,
            FilterCell: (statusProps: any) => {
                return <CustomDropdownFilterComponent {...statusProps} options={assetCategoryList?.current} setDropdown={assetCategorySelected} handleClearFilter={handleClearFilter}/>;
            },
            filterRowValue: getFilteredValue('assetCategory') ?? ''
        },
        {
            key: "equipmentClass",
            title: "Eq Class Code",
            width: 160,
            FilterCell: (statusProps: any) => {
                return <CustomDropdownFilterComponent {...statusProps} options={equipmentClassList?.current} setDropdown={equipmentClassSelected} handleClearFilter={handleClearFilter}/>;
            },
            filterRowValue: getFilteredValue('equipmentClass') ?? ''
        },
        {
            key: "equipmentClassDesc",
            title: "Eq Class Description",
            width: 200,
            filterRowValue: getFilteredValue('equipmentClassDesc') ?? ''
        },
        {
            key: "eqStatus",
            title: "Equipment Status",
            width: 200,
            filterRowValue: getFilteredValue('eqStatus') ?? ''
        },
        {
            key: "state",
            title: "State",
            width: 120,
            FilterCell: (statusProps: any) => {
                return <CustomDropdownFilterComponent {...statusProps} options={stateList?.current} setDropdown={stateSelected} handleClearFilter={handleClearFilter}/>;
            },
            filterRowValue: getFilteredValue('state') ?? ''
        },
        {
            key: "acquisitionCost",
            title: "Cost ($)",
            width: 100,
            Cell: (row: any) => {
                return (
                    row.rowData.acquisitionCost != null ? `$ ${formatPrice(row.rowData.acquisitionCost || 0, 2)}` : '$ 0.00'
                );
            },
            filterRowValue: getFilteredValue('acquisitionCost') ?? ''
        },
        {
            key: "netBookedValue",
            title: "Remaining Net Book Value ($)",
            width: 200,
            Cell: (row: any) => {
                return (
                    row.rowData.netBookedValue != null ? `$ ${formatPrice(row.rowData.netBookedValue || 0, 2)}` : null
                );
            },
            filterRowValue: getFilteredValue('netBookedValue') ?? ''
        },
    ]

    const onClickExport = (e?: any) => {
        e.preventDefault();
        fetchGridData("excel")
    }

    const searchOptions = [
        { value: 'assetNumber', label: 'Asset#' },
        { value: 'unitNumber', label: 'Unit#' },
        { value: 'vinNumber', label: 'Vin#' }
    ];

    const clearFilterValues = {
        assetNumber: '',
        unitNumber: '',
        vinNumber: '',
        costCenter: '',
        make: '',
        model: '',
        year: '',
        glCategory: '',
        assetCategory: '',
        equipmentClass: '',
        equipmentClassDesc: '',
        description: '',
        eqStatus: '',
        state: '',
        acquisitionCost: '',
        netBookedValue: '',
        globalSearchField: null,
        orderSearchBoxValue: '',
        loggedInMail: '',
        costCenterSearch: '',
        region: '',
        market: ''
    }

    const handleFilterClear = () => {
        setIsClearFilterClicked(true)
        dispatch(getRegionDropDown());
        setSelectedCostCenter('')
        setSelectedMarket('')
        setSelectedRegion('')
        setCostCenterDropdownList([])
        setMarketDropDownList([])
        dispatch(setActiveAssetGridFilter(clearFilterValues));
        setsearchBoxValue('')
        setGlobalSearchBy({ value: 'assetNumber', label: 'Asset #' })
        setShowGrid(false);

        costCenterSelected.current = ''
        makeSelected.current = ''
        modelSelected.current = ''
        yearSelected.current = ''
        glCategorySelected.current = ''
        assetCategorySelected.current = ''
        equipmentClassSelected.current = ''
        stateSelected.current = ''

        setTimeout(() => {
            setShowGrid(true);
        })
    }

    useEffect(() => {
        if (serverTotal && paginationData?.pageSize) {
            let pageSize = paginationData?.pageSize
            let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
            setPagesCount(tempPageCount)
        }
    }, [serverTotal, paginationData?.pageSize])

    const fetchAction = useCallback((fetchData: any) => {
        if (fetchData.action && fetchData.action === "paging") {
            let paginationData = fetchData.data
            setPaginationData(paginationData)
            dispatch(setActiveAssetGridFilter(paginationData));
        }
        if (fetchData.action && fetchData.action === "sorting") {
            const data = fetchData.data[0];
            setSortData(data);
            dispatch(setActiveAssetGridFilter({ sortData: data }));
        }
    }, [])

    const setFilters = (value: any) => {
        if (JSON.stringify(value) !== '{}') {
            dispatch(setActiveAssetGridFilter(value));
        }
    }

    const onSearchOrder = (e: any, isKeyPress?: any) => {
        setsearchBoxValue((isKeyPress ? e : e?.target?.value))
        dispatch(setActiveAssetGridFilter({ orderSearchBoxValue: (isKeyPress ? e : e?.target?.value), globalSearchField: globalSearchBy }));
    }

    const onGlobalSearchByChange = (value: any) => {
        setGlobalSearchBy(value)
        dispatch(setActiveAssetGridFilter({ globalSearchField: value }));
    }

    const handleSearchGrid = () => {
        resetToFirstPageOnNextFetchRef.current = true
        remountGridOnNextResponseRef.current = true
        if ((paginationData?.pageIndex ?? 0) !== 0) {
            syncPaginationToFirstPage()
            setGridRemountKey((key: number) => key + 1)
        }
        dispatch(setActiveAssetGridFilter({ ...activeAssetGridFilters, region: selectedRegion, market: selectedMarket, costCenterSearch: selectedCostCenter }))
        fetchGridData("grid")
    }

    const alreadyHasGridFilterValues = useCallback(() => {
        let isAlreadyHasValues = true
        let GridFilterValueTemp: any = activeAssetGridFilters;

        Object.keys(clearFilterValues)?.forEach((filterItem?: any) => {
            Object.keys(GridFilterValueTemp ?? {})?.forEach((gridItem?: any) => {
                if (filterItem == gridItem) {
                    let val = gridItem
                    if (GridFilterValueTemp[val] != "" && GridFilterValueTemp[val] != null && GridFilterValueTemp[val] != undefined && val != "globalSearchField" && val != "loggedInMail") {
                        isAlreadyHasValues = false
                    }
                }
            })
        });
        return isAlreadyHasValues
    }, [activeAssetGridFilters, selectedRegion, selectedMarket, selectedCostCenter, isClearFilterClicked])

    return (
        <ActiveAssetRegister
            breadcrumlist={breadcrumlist}
            handleChange={handleChange}
            regionDropDownList={regionDropDownList}
            selectedRegion={selectedRegion}
            activeAssetRegisterColumn={activeAssetRegisterColumn}
            marketDropDownList={marketDropDownList}
            selectedMarket={selectedMarket}
            costCenterDropdownList={costCenterDropdownList}
            selectedCostCenter={selectedCostCenter}
            onClickExport={onClickExport}
            searchOptions={searchOptions}
            globalSearchBy={globalSearchBy}
            handleFilterClear={handleFilterClear}
            fetchAction={fetchAction}
            setFilters={setFilters}
            serverTotal={serverTotal}
            pagesCount={pagesCount}
            onSearchOrder={onSearchOrder}
            onGlobalSearchByChange={onGlobalSearchByChange}
            searchBoxValue={searchBoxValue}
            showGrid={showGrid}
            isGridDataLoading={isGridDataLoading}
            activeAssetGridData={activeAssetGridData?.response?.data}
            handleSearchGrid={handleSearchGrid}
            alreadyHasGridFilterValues={alreadyHasGridFilterValues}
            isReport = {false}
            gridRemountKey={gridRemountKey}
        />
    )
}

export default ActiveAssetRegisterContainer
